__turbopack_context__.v({
  "container": "ComponentDatasheetHeaderImages-module-scss-module__yePO2G__container",
  "control": "ComponentDatasheetHeaderImages-module-scss-module__yePO2G__control",
  "controls": "ComponentDatasheetHeaderImages-module-scss-module__yePO2G__controls",
});
